import { render, staticRenderFns } from "./InputBtn.vue?vue&type=template&id=ad68aa8a&"
import script from "./InputBtn.vue?vue&type=script&lang=js&"
export * from "./InputBtn.vue?vue&type=script&lang=js&"
import style0 from "./InputBtn.vue?vue&type=style&index=0&id=ad68aa8a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports